export const style = {
  list: {
    editorText: {
      sx: {
        ml: 1,
        lineHeight: 1.1,
      },
    },
    divider: {
      sx: {
        padding: '4px 0px',
      },
    },
    sx: {
      width: '100%',
    },
    avatar: {
      sx: {
        width: 32,
        height: 32,
        p: 2,
        backgroundColor: 'action.active',
        fontSize: 14,
      },

    },
    listItem: {
      collapsedBlock: {
        display: 'flex',
        alignItems: 'center',

      },
      innerRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
      },
      sx: {
        width: '100%',
      },
      col: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 1,
        lineHeight: 1.1,
        '&: hover': {
          cursor: 'pointer',
        },
      },
      row: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      },
      Typography: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 200,
      },
    },
  },
} as const;
